import type { ConfigObjectMatch, ContentUpdateResult } from '@cli-types/next-adapter/init.js'
import { findTopLevelProperty } from './find-top-level-property.js'

export function removeTopLevelProperty(
  content: string,
  configObject: ConfigObjectMatch,
  propertyName: string
): ContentUpdateResult {
  const property = findTopLevelProperty(content, configObject.start, configObject.end, propertyName)
  if (!property) {
    return { content, changed: false }
  }

  const propertyLineStart = content.lastIndexOf('\n', property.propertyStart) + 1
  let propertyEnd = property.valueEnd

  if (content[propertyEnd] === ',') propertyEnd++
  if (content[propertyEnd] === '\r') propertyEnd++
  if (content[propertyEnd] === '\n') propertyEnd++

  return {
    content: content.slice(0, propertyLineStart) + content.slice(propertyEnd),
    changed: true
  }
}
